import  { useEffect, useState } from 'react';

import Keycloak from 'keycloak-js';

import { sendAllDataPost_byApiNameAndData } from '../posts/postdata';

import {User} from '@plasma/ui.application.app-provider';
import type { AvatarConfig, AvatarAction } from '@plasma/ui.application.app/dist/app.types.d.ts';

import { UserInfoKeyCloak } from '../../types/usersDataType';
import Notification from '@plasma/ui.feedback.notification';
import { UsersDataType } from '../../types/usersDataType';
import { routes } from '../../routes';
import {history} from '@plasma/ui.application.router';
import { KeycloakAutUrl, KeycloakClient, KeycloakRealm } from '../conf/apiConf';

import { headers_custom_func_set, headers_custom_func_set_logoff, setUserFunction, headers_custom_func_get } from './get_set_AuthHeaders';


const KeycloakWrapper = ({ children }) => {
  const [keycloak, setKeycloak] = useState(null);
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState<User>();
  const [userkeyCloak, setUserKeyCloak] = useState<User>();
  const [routesToUse, setRoutesToUse] = useState([]);
  const [logoAndTitle, setlogoAndTitle] = useState({logo: "", title: "", useLogo: false});

  let avatarConfigs: AvatarConfig = {};
  let avatarActions: AvatarAction[] = [];

  const companyId= sessionStorage.getItem('companyID');
  const superUserRole= sessionStorage.getItem('superUserRole');
  const apiName = 'UserLoggedIn';

  //console.log('super role: ', superUserRole);

  useEffect(() => {
    const keycloakInstance = new Keycloak({
      url: KeycloakAutUrl,
      realm: KeycloakRealm,
      clientId: KeycloakClient,
    });
    //console.log(keycloakInstance);
    // checkLoginIframe: false skips keycloak-js's hidden third-party-cookie / session-status iframes. Browsers
    // that block third-party cookies never answer them ("Timeout when waiting for 3rd party check iframe
    // message"), which made init fail; the app doesn't use the session-status polling they provide.
    keycloakInstance.init({ onLoad: 'login-required', checkLoginIframe: false }).then((authenticated) => {
      setKeycloak(keycloakInstance);
      //setAuthenticated(authenticated);
      if (authenticated) {

        let userINfoNew: User;
        // Get user information
        keycloakInstance.loadUserInfo().then((userInfo: UserInfoKeyCloak) => {
          setUserKeyCloak(userInfo);

          userINfoNew = {
            id: userInfo.preferred_username,
            avatar: null,
            email: userInfo.email,
            firstName: userInfo.given_name,
            lastName: userInfo.family_name,
            hasFullPermission: true,
            permissions: keycloakInstance?.tokenParsed?.resource_access?.[KeycloakClient]?.roles,
            userName: userInfo.preferred_username,
            domain: userInfo.email.split('@')[1].split('.')[0],
            sub: userInfo.sub
          };
          //console.log({userINfoNew}, {userInfo});
          sessionStorage.setItem('UserRoles', JSON.stringify(userINfoNew.permissions));
          if(
            userINfoNew.permissions?.includes('Ts-admin') &&
            (!companyId || companyId === "0" || companyId.trim().length === 0)
          )
          {
            sessionStorage.setItem('superUserRole', 'Ts-admin');
            history.push('/create-new-project');
          }
          else{
            history.push('/home-screen');
          }

          setUserFunction(userINfoNew);
          setUser(userINfoNew);
        });
      }
    }).catch((error) => {
      // keycloak-js rejects with a plain object such as { error: '...' }, or with nothing at all
      console.error('Keycloak init failed:', error);
    });
  }, []);

  const startLogoutTimer = () => {
    let logoutTimeout: any;
    let additionalActionTimeout: any;
    let lastWarningTimeout: any;

    const resetTimer = () => {

      clearTimeout(logoutTimeout);
      clearTimeout(additionalActionTimeout);
      clearTimeout(lastWarningTimeout);

      // Set timeout for showing a notification after 5 seconds
      additionalActionTimeout = setTimeout(() => {
        //console.log("Additional action at 28 minutes");
        Notification.info('Info', 'You have been inactive for 28 Mins, Session will timeOut in 2 mins', undefined, 'medium', 3);
        // Add your additional action logic here
      }, 28 * 60 * 1000);

      // Set timeout for showing a last warning after 10 seconds
      lastWarningTimeout = setTimeout(() => {
        console.log("Last warning at 28 minutes");
        Notification.warning('Info', 'Will logoff in 30 seconds', undefined, 'medium', 3);
        // Add your last warning action logic here
      }, (29 * 60 + 30) * 1000);

      // Set timeout for logging off after 15 seconds
      logoutTimeout = setTimeout(() => {
        handleLogout();
      }, 30 * 60 * 1000);
    };

    const handleMouseMove = () => {
      resetTimer();
      //Notification.success('Info', 'Session reactivated', undefined, 'medium', 3);
      //window.removeEventListener('mousemove', handleMouseMove);
    };

    const handleKeyDown = () => {
      resetTimer();
      //window.removeEventListener('keydown', handleKeyDown);
    };

    // Initial setup
    resetTimer();
    //console.log("event listner added");
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      clearTimeout(logoutTimeout);
      clearTimeout(additionalActionTimeout);
      clearTimeout(lastWarningTimeout);
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('keydown', handleKeyDown);
    };
  };

  //console.log('com id: ',companyId);

  useEffect(()=> {

    const item:UsersDataType = {
      sessionid: user?.sub,
      username: user?.userName,
      email: user?.email,
      employeeid: user?.id,
      company: user?.domain,
      contactno: null,
      remarks: null,
    };


    sendAllDataPost_byApiNameAndData("UserLoggedIn", item)
      .then((response)=>{
        if(userkeyCloak){
          //console.log('response: ',response[0]);
          const superRole = keycloak?.tokenParsed?.resource_access?.[KeycloakClient]?.roles;
          startLogoutTimer();
          if(response[0].roleid !== 99){
            //console.log("Filtered routes");
            setRoutesToUse(routes.filter((oneRoute) => oneRoute.path !== '/user-master-data' && oneRoute.path !== '/master-data'));
          }
          else{
            //console.log("All routes");
            setRoutesToUse(routes);
          }
          headers_custom_func_set({...userkeyCloak, roleid: response[0].roleid});
          if(!superRole?.includes('Ts-admin')){
            sessionStorage.setItem('companyID', response[0].companyid);
          }
          //const companyName1 = userkeyCloak && userkeyCloak.email.split('@')[1].split('.')[0];

          // companylogo comes back as an empty string when the backend couldn't fetch the
          // logo (missing file, Minio unreachable, etc.) - only build a data URI when there's
          // actually a payload, otherwise a bogus "data:" src gets set and the logo image sits
          // broken/loading forever with no visible failure.
          const fetchedLogo = response[0].companylogo ? 'data:' + response[0].companylogo : '';

          setlogoAndTitle((prev) => ({
            ...prev,
            logo: fetchedLogo,
            ...(superRole?.includes('Ts-admin')
              ? { title: 'SMS Consumables', useLogo: true }
              : {}),
          }));

          setAuthenticated(true);
        }
      })
      .catch((error)=>{
        console.log("LOGIN UNSUCCESSFUL", error);

      });

  },[user]);

  const handleLogout = () => {
    if (keycloak) {
      history.push('/home-screen');
      const item:UsersDataType = {
        sessionid: user?.sub,
        username: user?.userName,
        email: user?.email,
        employeeid: user?.id,
        company: user?.domain,
        contactno: null,
        remarks: null
      };

      sendAllDataPost_byApiNameAndData("UserLogOut", item)
      .then((response)=>{
        if(superUserRole?.length)
        {
          sessionStorage.removeItem('superUserRole');
        }
        if(sessionStorage.getItem('UserRoles'))
        {
          sessionStorage.removeItem('UserRoles');
        }
        headers_custom_func_set_logoff(); //unset he headers
      })
      .catch((error)=>{//if logoff is unsuccessful.
        console.log("LOGOUT API CALL UNSUCCESSFUL");
        //if error creating session then logoff the user and redirect to login.
      })
      .finally(() => {
        keycloak.logout(); // logout of keycloak.
      });

    }
  };

  const handleResetPassword = () => {
    // Add logic for resetting password
    console.log('Resetting password...');
    Notification.info('Info','Use Forgot Password option on the login page',undefined,'medium',3);
   // handleLogout();
  };

  const resetPasswordAction: AvatarAction = {
    label: "Reset Password",
    iconName: "lock",
    action: handleResetPassword,
  };

  avatarActions.push(resetPasswordAction);

  avatarConfigs = {
    actions: avatarActions,
    onLogout: handleLogout, // Optionally, you can set the onLogout callback
    hide: false,
  };

  const keycloakWrapperdata = {
    avatarConfigs: avatarConfigs,
    user: user,
    authenticated: authenticated,
    routes: routesToUse,
    logoandtitle: logoAndTitle
  }

  return keycloak ? children(keycloakWrapperdata) : null;
};


export default KeycloakWrapper;
